/* global payhere */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./payment.css";

const loadPayHereScript = () => {
  return new Promise((resolve, reject) => {
    console.log("Attempting to load PayHere SDK...");
    const script = document.createElement("script");
    script.src = "https://www.payhere.lk/lib/payhere.js";
    script.onload = () => {
      console.log("PayHere SDK loaded successfully.");
      resolve();
    };
    script.onerror = () => {
      console.error("Failed to load PayHere SDK.");
      reject(new Error("PayHere script load error"));
    };
    document.body.appendChild(script);
  });
};

function Payment() {
  const navigate = useNavigate();
  const location = useLocation();

  const totalAmount = location.state?.totalAmount || 0;
  const cartItems = location.state?.cartItems || [];

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    state: "",
    city: "",
    zip: "",
    deliveryMethod: "normal",
  });

  const deliveryFee = formData.deliveryMethod === "normal" ? 450 : 0;
  const orderTotal = totalAmount + deliveryFee;
  const [isPayHereLoaded, setIsPayHereLoaded] = useState(false);

  useEffect(() => {
    loadPayHereScript()
      .then(() => {
        console.log("PayHere script loaded, checking initialization...");
        if (window.payhere?.startPayment) {
          console.log("PayHere initialized successfully.");
          setIsPayHereLoaded(true);
        } else {
          console.error("PayHere not initialized properly.");
        }
      })
      .catch((error) => {
        console.error("Failed to load PayHere script:", error);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePayment();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };



  const handlePayment = async () => {
    // Check if the PayHere gateway is loaded and if the startPayment function is available
    if (!isPayHereLoaded || !window.payhere.startPayment) {
      alert("Payment gateway is not ready yet. Please try again.");
      return;
    }
  
    // Fetch payment data and hash from the backend
    const paymentData = await fetchPaymentHash();
    if (!paymentData) return;
  
    console.log("Initiating payment with details:", paymentData);
  
    // Set up the success, dismiss, and error callbacks for the payment
    window.payhere.onCompleted = function (orderId) {
      console.log("Payment Successful! Order ID: " + orderId);
      
      // Navigate to success page with orderId in the state
      navigate("/success", { state: { orderId } });
    };
  
    window.payhere.onDismissed = function () {
      alert("Payment was dismissed.");
    };
  
    window.payhere.onError = function (error) {
      alert("Payment Error: " + error);
    };
  
    window.payhere.onCancelled = function () {
      console.log("Payment was cancelled by the user.");
      alert("Payment was cancelled. Please try again.");
      
      // Optionally, navigate to the cancel page
      navigate("/cancel");
    };
  
    // Start the payment process
    window.payhere.startPayment(paymentData);
  };

  
  
  // Function to fetch the payment hash from the backend
  const fetchPaymentHash = async () => {
    const paymentDetails = {
      order_id: `order_${Date.now()}`,
      amount: orderTotal.toFixed(2),
      currency: "LKR",
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      address: formData.address,
      city: formData.city,
      country: "Sri Lanka",
    };
  
//after navigate to the success.js cart has to clear wich is order is complete.


    try {
      console.log("Requesting hash from backend...");
  const response = await fetch("https://eyecareclinicandoptical.com/api/payment.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(paymentDetails),
      });
  
      if (response.ok) {
        const { hash, merchant_id } = await response.json();
  
        // Return the full payment data required by PayHere
        return {
          sandbox: false,
          merchant_id: merchant_id,
          return_url: "https://eyecareclinicandoptical.com/success",
          cancel_url: "https://eyecareclinicandoptical.com/cancel",
          notify_url: "https://eyecareclinicandoptical.com/api/notify.php",
          order_id: paymentDetails.order_id,
          items: cartItems.map((item) => `${item.name} (${item.quantity})`).join(", "),
          amount: paymentDetails.amount,
          currency: paymentDetails.currency,
          first_name: paymentDetails.first_name,
          last_name: paymentDetails.last_name,
          email: paymentDetails.email,
          phone: paymentDetails.phone,
          address: paymentDetails.address,
          city: paymentDetails.city,
          country: paymentDetails.country,
          hash: hash,
        };
      } else {
        console.error("Failed to generate hash for payment.");
        alert("Error processing payment. Please try again.");
        return null;
      }
    } catch (error) {
      console.error("An error occurred:", error);
      alert("An unexpected error occurred.");
      return null;
    }
  };
  




  return (
    <div className="payment-container">
      <h2>Checkout</h2>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="personal-details">
            <h3>Personal Details</h3>
            <label>Email Address</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            <label>First Name</label>
            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
            <label>Last Name</label>
            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
            <label>Phone Number</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
            <label>Street Address</label>
            <input type="text" name="address" value={formData.address} onChange={handleChange} required />
            <label>State / Province</label>
            <input type="text" name="state" value={formData.state} onChange={handleChange} required />
            <label>City</label>
            <input type="text" name="city" value={formData.city} onChange={handleChange} required />
            <label>Zip / Postal Code</label>
            <input type="text" name="zip" value={formData.zip} onChange={handleChange} required />
          </div>



          <div className="delivery-method">
            <h3>Delivery Method</h3>
            <label>
              <input type="radio" name="deliveryMethod" value="normal" checked={formData.deliveryMethod === "normal"} onChange={handleChange} />
              Normal Delivery (Rs. 450)
            </label>
            <label>
              <input type="radio" name="deliveryMethod" value="pickup" checked={formData.deliveryMethod === "pickup"} onChange={handleChange} />
              Store Pickup - Colombo 08 (Free)
            </label>
          </div>
        </div>

        <div className="cart-summary">
        <h3>Order Summary</h3>
        <table className="summary-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Product</th>
              <th>Price</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {cartItems.length > 0 ? (
              cartItems.map((item) => (
                <tr key={item.id}>
                  <td><img src={item.image} alt={item.name} className="summary-image" /></td>
                  <td className="summary-table-data">{item.name}</td>
                  <td className="summary-table-data">Rs. {item.price.toLocaleString()}</td>
                  <td className="summary-table-data">{item.quantity}</td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="4">No items in cart.</td></tr>
            )}
          </tbody>
        </table>
      </div>



        <div className="order-review">

          <p>Delivery Fee: Rs. {deliveryFee}</p>
          <h3>Order Total: Rs. {orderTotal}</h3>
        </div>

        <button type="submit" className="submit-btn" disabled={!isPayHereLoaded || typeof window.payhere?.startPayment !== "function"}>
          {isPayHereLoaded ? "Place Order Now" : "Loading..."}
        </button>
      </form>
    </div>
  );
}

export default Payment;
